// custom-hero-slider js
document.addEventListener("DOMContentLoaded", function () {
    let slides = document.querySelectorAll(".custom-hero-slider .hero-slider .slide");
    let dotsContainer = document.querySelector(".dots");
    let index = 0;

    // create dots
    slides.forEach((_, i) => {
      let dot = document.createElement("span");
      dot.addEventListener("click", () => {
        index = i;
        showSlide(index);
      });
      dotsContainer.appendChild(dot);
    });

    let dots = document.querySelectorAll(".dots span");

    function showSlide(i){
      slides.forEach(s => s.classList.remove("active"));
      dots.forEach(d => d.classList.remove("active"));

      slides[i].classList.add("active");
      dots[i].classList.add("active");
    }

    showSlide(index);

    document.querySelector(".next").onclick = function(){
      index = (index + 1) % slides.length;
      showSlide(index);
    }

    document.querySelector(".prev").onclick = function(){
      index = (index - 1 + slides.length) % slides.length;
      showSlide(index);
    }
});
// custom-hero-slider js end



function toggleAccordion(btn) {
  const item = btn.closest('.accordion-wrapper .accordion-item');
  const isOpen = item.classList.contains('open');
  if (isOpen) {
    item.classList.remove('open');
  } else {
    item.classList.add('open');
  }
}




document.querySelectorAll('.template-collection .collection__container').forEach(container => {
    let productCount = 0;
    container.querySelectorAll(':scope > *').forEach(item => {
        if (!item.classList.contains('product-card')) return;
        productCount++;
        item.classList.remove('grid-four', 'grid-three');

        if ((productCount - 1) % 7 < 4) {
            item.classList.add('grid-four');
        } else {
            item.classList.add('grid-three');
        }
    });
});